import { useI18n } from 'vue-i18n'

export const FUEL_TYPE_VALUES = {
  DIESEL: 'diesel',
  PETROL: 'petrol',
  ELECTRIC: 'electric',
} as const

const FUEL_TYPE_TRANSLATION_KEYS: Record<string, string> = {
  [FUEL_TYPE_VALUES.DIESEL]: 'fuelTypeDiesel',
  [FUEL_TYPE_VALUES.PETROL]: 'fuelTypePetrol',
  [FUEL_TYPE_VALUES.ELECTRIC]: 'fuelTypeElectric',
}

export function useFuelTypes() {
  const { t } = useI18n()

  const fuelTypeOptions = Object.values(FUEL_TYPE_VALUES).map((value) => ({
    title: t(FUEL_TYPE_TRANSLATION_KEYS[value]),
    value,
  }))

  const translateFuelType = (value: string | null | undefined) => {
    if (!value) {
      return value
    }
    const key = FUEL_TYPE_TRANSLATION_KEYS[value.toLowerCase()]
    return key ? t(key) : value
  }

  return { fuelTypeOptions, translateFuelType }
}
